import { AppBar, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomAppBar = styled(AppBar)(({ theme, options }) => {
    return {
        top: 'auto',
        bottom: 0,
        zIndex: theme.zIndex.drawer + 1,
        borderTop: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: 0,
        padding: theme.spacing(3, 7),
        background:
            options?.background === 'primary'
                ? theme.palette.ensightful.primary[50]
                : theme.palette.ensightful.shades[0],
    };
});

const BottomBar = forwardRef(({ children, options, ...rest }, ref) => {
    return (
        <CustomAppBar ref={ref} {...rest} options={options} position={'fixed'}>
            {children}
        </CustomAppBar>
    );
});

export default BottomBar;
